// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';


Vue.config.productionTip = false;

//全局加载resource拦截器
import './axios/';
import Axios from 'axios';

Vue.prototype.$http = Axios;

Axios.defaults.baseURL = '/scfb/api';

import {Layout,Row, Col} from "ant-design-vue";
import {Button} from "ant-design-vue";
import {Menu} from "ant-design-vue";
import {Breadcrumb} from "ant-design-vue";
import {Icon} from "ant-design-vue";
import {Dropdown} from "ant-design-vue";
import {Input} from "ant-design-vue";
import {Carousel} from "ant-design-vue";
import {Calendar} from "ant-design-vue";
import {List} from "ant-design-vue";
import {ConfigProvider} from "ant-design-vue";
import {Select} from "ant-design-vue";
import {Radio} from "ant-design-vue";
import {Badge} from "ant-design-vue";
import {PageHeader} from "ant-design-vue";
import {Descriptions} from "ant-design-vue";
import {Divider} from "ant-design-vue";
import {Steps} from "ant-design-vue";
import {FormModel} from "ant-design-vue";
import {Switch} from "ant-design-vue";
import {Card} from "ant-design-vue";
import {DatePicker} from "ant-design-vue";
import {Checkbox} from "ant-design-vue";
import {Tabs} from "ant-design-vue";
import {Avatar} from "ant-design-vue";
import {Upload} from "ant-design-vue";
import {Pagination} from "ant-design-vue";
import {Modal} from "ant-design-vue";


Vue.use(Layout);
Vue.use(Button);
Vue.use(Menu);
Vue.use(Breadcrumb);
Vue.use(Row);
Vue.use(Col);
Vue.use(Icon);
Vue.use(Dropdown);
Vue.use(Input);
Vue.use(Carousel);
Vue.use(Calendar);
Vue.use(List);
Vue.use(ConfigProvider);
Vue.use(Select);
Vue.use(Radio);
Vue.use(Badge);
Vue.use(PageHeader);
Vue.use(Descriptions);
Vue.use(Divider);
Vue.use(Steps);
Vue.use(FormModel);
Vue.use(Switch);
Vue.use(Card);
Vue.use(DatePicker);
Vue.use(Checkbox);
Vue.use(Tabs);
Vue.use(Avatar);
Vue.use(Upload);
Vue.use(Pagination);
Vue.use(Modal);





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js